






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { add, update } from '@/api/platform'
import { getUploadPicSign } from '@/api/common'
import { DetailsProps } from '../index.d'
import axios from 'axios'

interface PicProps {
  authorization: string
  policy: string
  url: string
}

@Component({
  name: 'OperationModal'
})
export default class extends Vue {
  @Prop({ default: false }) operationDialogFlag!: boolean
  @Prop() detail!: DetailsProps
  private visible = false
  private formParams = {
    name: '',
    url: '',
    identification: '',
    logo: ''
  }

  private loading = false

  private select = '1'

  private rules = {
    name: [{ required: true, message: '请输入平台名称', trigger: 'change' }],
    url: [{ required: true, message: '请输入平台地址', trigger: 'change' }],
    identification: [{ required: true, message: '请输入平台标识', trigger: 'change' }],
    logo: [{ required: true, message: '请上传平台logo', trigger: 'change' }]
  }

  // 自定义上传图片方法
  private async httpRequest({ file }: { file: any }) {
    this.loading = true
    const params = {
      path: '/',
      filename: file.name,
      suffix: file.type
    }
    const { data } = await getUploadPicSign<PicProps>(params)
    const formData = new FormData()
    formData.append('file', file)
    formData.append('policy', data.policy)
    formData.append('authorization', data.authorization)
    const picRes: any = await axios.post('http://v1.api.upyun.com/hmpic', formData)
    if (picRes.data.code === 200) {
      this.formParams.logo = `https://pic.hoomi.cn${picRes.data.url}`
      this.loading = false
    }
  }

  private close() {
    this.select = '1'
    this.$nextTick(() => (this.$refs.form as ElForm).resetFields())
    this.$emit('update:operationDialogFlag', false)
  }

  private onSubmit() {
    (this.$refs.form as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        const url = this.select === '1' ? `https://${this.formParams.url}` : `http://${this.formParams.url}`
        this.detail ? await update({ ...this.formParams, url, id: this.detail.id }) : await add({ ...this.formParams, url })
        this.detail ? this.$message.success('修改成功') : this.$message.success('新增成功')
        this.$emit('onsubmit')
        this.close()
      }
    })
  }

  @Watch('operationDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.operationDialogFlag
    if (this.visible && this.detail) {
      // 数据回填
      let { name, logo, url, identification } = this.detail
      const str = url.substring(0, 7)
      const str1 = url.substring(0, 8)
      this.$nextTick(() => {
        if (str === 'http://') {
          url = url.slice(7)
          this.select = '2'
        } else if (str1 === 'https://') {
          url = url.slice(8)
          this.select = '1'
        }
        this.formParams = { name, logo, url, identification }
      })
    }
  }
}
